import './completed.scss'

import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { ReactNode, useMemo } from 'react'

import Header from '../../components/collections/Header'
import { NoticeMessage } from '../../constants'
import TagManager from '../../lib/tag-manager'
import { useAppState } from '../../providers/store'

interface CompletedPageProps {
    headerTitle?: string
    title?: string
    content?: string | ReactNode
}

const onClickClose = (appState: Record<string, any>) => () => {
    const context = appState.kycContext || 'repayment'
    const messages = {
        'loan-stage': {
            type: 'text',
            text: 'ยืนยันตัวตนสำเร็จ สามารถเลือกหัวข้อที่ต้องการสอบถามจากเมนูด้านล่างได้เลยค่ะ',
        },
        repayment: { type: 'text', text: 'ยืนยันตัวตนสำเร็จ กดดูยอด/จ่ายค่างวดอีกครั้ง' },
        ptp: { type: 'text', text: 'ยืนยันตัวตนสำเร็จ กดปุ่มกรอกแบบฟอร์มเพื่อเลื่อนนัดชำระ' },
        pdpa: {
            type: 'text',
            text: 'ยืนยันตัวตนสำเร็จ กรุณากดปุ่มเพื่อเริ่มกรอกแบบฟอร์มยกเลิกการให้ความยินยอมเปิดเผยข้อมูลเพื่อวัตถุประสงค์ทางการตลาด (cross-sell)',
        },
        campaign: {
            type: 'text',
            text: 'ยืนยันตัวตนสำเร็จ แนะนำแอป Money Thunder ให้กับเพื่อนได้เลย',
        },
    }
    try {
        if (window.liff.isInClient()) {
            if (context === 'campaign') {
                window.location.href = `https://liff.line.me/${process.env.SHARING_CAMPAIGN}`
            } else {
                window.liff.sendMessages([messages[context]])
                window.liff.closeWindow()
            }
        } else {
            window.close()
        }
    } catch (error) {
        console.error(error)
    }
}

const CompletedPage: React.FC<CompletedPageProps> = ({ content, headerTitle, title }) => {
    const appState = useAppState()
    useMemo(() => {
        TagManager.loadEvent({ page: 'verification_success' })
    }, [])

    const isKYCForCampaign = appState.kycContext === 'campaign'

    return (
        <div className="completed">
            <Header
                title={headerTitle || 'ยืนยันตัวตน'}
                cancelable={false}
                messages={
                    isKYCForCampaign
                        ? []
                        : [
                              {
                                  type: 'text',
                                  text: NoticeMessage.ABORTED_AUTHEN_LINE_SHARING,
                              },
                          ]
                }
            />
            <div className="container abcs-container">
                <FontAwesomeIcon
                    className="checked-with-circle-container"
                    icon={faCheckCircle}
                    size="4x"
                />
                <h6>{title || 'ยืนยันตัวตนสำเร็จ'}</h6>
                <p>
                    {content ||
                        'ท่านได้เชื่อมต่อข้อมูลระหว่างแอปเงินเทันเด้อ และ LINE เรียบร้อยแล้ว'}
                </p>
            </div>
            <footer className="abcs-container">
                <button
                    type="button"
                    className="abcs-button primary fluid"
                    onClick={onClickClose(appState)}
                >
                    {isKYCForCampaign ? 'แชร์เลย' : 'ปิด'}
                </button>
            </footer>
        </div>
    )
}

export default CompletedPage
